import { Separator, Table, TableCell, TableRow } from 'telia-front-react';
import * as React from 'react';
import { formatAsCurrency } from '../../../util/FormatUtil';
import { InterestDetails } from '../../../stores/models/InvoiceDetails';
import { useStores } from '../../../stores/RootStore';

const InvoiceDetailsInterestsTable = () => {
  const { translateStore, invoiceDetailsStore, invoiceNameStore } = useStores();
  const { translate, translateHtml } = translateStore;
  const unsettledInterests = invoiceDetailsStore.invoiceDetails?.payload?.details.unsettledInterests;

  const renderTableHeadings = (): JSX.Element => {
    return (
      <TableRow>
        <TableCell type="th">{translate('shared.invoice-details-modal.interests.invoice-date')}</TableCell>
        <TableCell type="th">{translate('shared.invoice-details-modal.interests.invoice-name')}</TableCell>
        <TableCell type="th">{translate('shared.invoice-details-modal.interests.invoice-number')}</TableCell>
        <TableCell type="th">{translate('shared.invoice-details-modal.interests.due-date')}</TableCell>
        <TableCell type="th">{translate('shared.invoice-details-modal.interests.total-sum')}</TableCell>
      </TableRow>
    );
  };

  return (
    <>
      <div
        dangerouslySetInnerHTML={translateHtml('shared.invoice-details-modal.interests.explanation', {
          totalSum: formatAsCurrency(unsettledInterests.standingTotalAmount)
        })}
      />
      <Separator color="invisible" spacing="xsmall" />
      <Table responsive="cols" break="sm">
        <thead>{renderTableHeadings()}</thead>
        <tbody>
          {unsettledInterests?.interests.map((interest: InterestDetails, index: number) => (
            <TableRow id={`interest-details-row-${index}`}>
              <TableCell id={`interest-details-due-date-${index}`}>{interest.invoiceDate}</TableCell>
              <TableCell id={`interest-details-name-${index}`}>
                {interest.refNumberAlias ||
                  (invoiceNameStore.invoiceName(invoiceDetailsStore.findInvoiceByNumber(interest.invoice)) && (
                    <p>
                      {interest.refNumberAlias
                        ? interest.refNumberAlias
                        : invoiceNameStore.invoiceName(invoiceDetailsStore.findInvoiceByNumber(interest.invoice))}
                    </p>
                  ))}
                <p className="text-light">{interest.refNumber}</p>
              </TableCell>
              <TableCell id={`interest-details-invoice-number-${index}`}>
                <p>{interest.invoice}</p>
              </TableCell>
              <TableCell id={`interest-details-due-date-${index}`}>{interest.dueDate}</TableCell>
              <TableCell id={`interest-details-interest-amount-${index}`}>{formatAsCurrency(interest.interestAmount, 4)}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default InvoiceDetailsInterestsTable;
